import {
  isFlatMultipleOptions,
  isNestedMultipleOptions,
  isSingleOption,
  MapFilters,
} from "./types/filters";

export function getUniqueQueryKeys(filters: MapFilters) {
  const allowedKeysSet = new Set<string>();
  filters.entries.forEach(entry => {
    if (isSingleOption(entry) || isFlatMultipleOptions(entry)) {
      allowedKeysSet.add(entry.values[0].name);
    } else if (isNestedMultipleOptions(entry)) {
      allowedKeysSet.add(entry.values[0].value[0].name);
    }
  });
  return Array.from(allowedKeysSet);
}
